module.exports = __webpack_public_path__ + "static/img/active-button.cf2770db.png";